import { Drawer, Divider, Box } from '@mui/material';

import { useLayoutContext } from 'modules/common/components/Layout/LayoutContext';
import DrawerHeader from 'modules/common/components/Layout/Sidebar/Mobile/DrawerHeader';
import DrawerFooter from 'modules/common/components/Layout/Sidebar/Mobile/DrawerFooter';
import SidebarList from 'modules/common/components/Layout/Sidebar/common/SidebarList';
import useMenuAreas from 'modules/common/components/Layout/Sidebar/useMenuAreas';
import Item from 'modules/common/components/Layout/Sidebar/Item';
import useSubMenu from 'modules/common/components/Layout/Sidebar/common/useSubMenu';

export default function MobileSidebar() {
    const { isSidebarHidden, setIsSidebarHidden } = useLayoutContext();
    const menuAreas = useMenuAreas();

    const hideSidebar = () => {
        setIsSidebarHidden(true);
    };

    const [subMenuSelected, setSubMenuSelected] = useSubMenu();

    return (
        <Drawer
            open={!isSidebarHidden}
            onClose={hideSidebar}
            variant="temporary"
            anchor="left"
            aria-label="sidebar"
            sx={{
                minWidth: 300,
                width: '75%',
            }}
            PaperProps={{
                sx: {
                    minWidth: 300,
                    width: '75%',
                    borderRadius: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: 'cement.50',
                },
            }}>
            <Box sx={{ overflow: 'hidden', height: '100%' }}>
                <DrawerHeader />
                <Divider />
                <SidebarList sx={{ px: 1.5, height: 'calc(100% - 90px)', overflow: 'auto' }}>
                    {menuAreas.map((item) => (
                        <Item
                            subMenuSelected={subMenuSelected}
                            setSubMenuSelected={setSubMenuSelected}
                            isSidebarCollapsed={isSidebarHidden}
                            {...item}
                            key={item.name}
                        />
                    ))}
                </SidebarList>
            </Box>
            <div>
                <Divider />
                <DrawerFooter />
            </div>
        </Drawer>
    );
}
